import { sum } from 'lodash-es';
import type { Airflow } from '@aviata/platform-types';
import { isTicket } from '../types/guards';

export const getTicketPrice = (
  productsList: Airflow.Order.Entity['products'],
) => {
  const ticketsList = productsList.filter(isTicket);
  const prices = ticketsList.map(ticket => Number(ticket.total));
  return sum(prices);
};
